import Utils from '@/providers/Utils'
import Vue from "vue";
import pdfMake from 'pdfmake';
const firebase = require('firebase')
const moment = require('moment')

export default {

    // -------- tool options ----------

    toolName: 'checklistMaker',
    label: 'Checklist Maker',
    logo: '',

    getDefaultData() {
        return {
            docTitle: 'Untitled',
            currentStep: 1,
            fontFace: 'sans',
            fontSize: 'large',

            checklistType: null,

            cardTitle: null,
            studentName: null,

            checklistItems: [],
            createdForms: [],

            tabIndex: 0,
        }
    },

    steps: [
        {id: 1, title: 'Checklist Type'},
        {id: 2, title: 'Header Information'},
        {id: 3, title: 'Checklist Items'}
    ],

    // define which download methods are supported - see ToolContainerPreviewToolbar::inject
    provide: function() {
        return {
            downloadDocFile: null,
            downloadPdfFile: this.doDownloadPdfFile,
            exportToGoogleForms: this.doExportToGoogleForms
        }
    },

    methods: {
        async doExportToGoogleForms() {
            this.$store.state.createFormLoading = true
            let items = []
            for (let item in this.docData.checklistItems) {
                items.push(this.docData.checklistItems[item])
            }
            const data = {
                cardTitle: this.docData.cardTitle,
                //checklistType: this.config.checklistMaker.checklistTypes[this.docData.checklistType - 1].title,
                studentName: this.docData.studentName,
                checklistItems: items,
                userEmail: this.$store.state.currentUserEmail
            };

            const makeForm = firebase.functions().httpsCallable('makeForm');
            makeForm(data)
                .then((result) => {
                    const res = result.data;
                    const timeOptions = {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric"
                    }
                    const formData = {
                        editLink: res.editorLink,
                        respondLink: res.responderLink,
                        formId: res.formId,
                        createdTime: moment().toDate().toLocaleDateString("en-US", timeOptions)
                    };

                    Vue.set(this.docData, 'createdForms', _.concat(
                        this.docData.createdForms ? this.docData.createdForms : [], [formData]
                    ));
                    this.$store.state.createFormLoading = false;
                });
        },

        async deleteGoogleForm(id) {
            if(confirm("Would you like to delete this Google Form? Once deleted, the Google Form cannot be recovered.")) {
                this.$store.state.deleteFormLoading = id
                const deleteForm = firebase.functions().httpsCallable('deleteForm');
                deleteForm(id)
                    .then((result) => {
                        this.docData.createdForms = this.docData.createdForms.filter(function( form ) {
                            return form.formId !== id;
                        });
                        this.$store.state.deleteFormLoading = null
                    });
            }
        },

        doDownloadPdfFile() {
            this.initPdfMakeFonts()
            const dd = this.getPdfBaseDocDefinition()

            const headerContent = []
            headerContent.push(
                {
                    text: this.docData.cardTitle,
                    alignment: 'center',
                    fontSize: 20,
                    bold: true,
                    lineHeight: 1,
                },
                {
                    text: this.config.checklistMaker.checklistTypes[this.docData.checklistType-1].title + ' for ' + this.docData.studentName,
                    alignment: 'center',
                    fontSize: 14,
                    lineHeight: 2,
                },
                {
                    text: 'Directions: Review each of the checklist items below and rate accordingly.',
                    alignment: 'left',
                    fontSize: 12,
                    lineHeight: 3
                },

            )

            let tableContent = []
            tableContent.push(
                {
                    style: 'headerLineOnly',
                    writable: true,
                    table: {
                        widths: [200, 10, '*'],
                        body: [
                            [
                                {border: [false, true, false, true], bold: true, text: 'Item'},
                                {border: [false, true, false, true], text: ''},
                                {border: [false, true, false, true], bold: true, text: 'Rating'},
                            ]
                        ]
                    },
                }
            )

            _.each(this.docData.checklistItems, item => {
                let tableItem = {
                    writable: true,
                    table: {
                        widths: [],
                        body: []
                    },
                    layout: 'noBorders'
                }
                tableItem.table.body.push([item.text])
                tableItem.table.widths.push(200)
                tableItem.table.body[0].push('')
                tableItem.table.widths.push(10)
                _.each(item.responses, response => {
                    tableItem.table.body[0].push(response.value)
                    tableItem.table.widths.push('*')
                })

                tableContent.push("\n")
                tableContent.push(tableItem)
                tableContent.push("\n")
            })

            dd.content = _.concat(headerContent, tableContent)

            console.log(dd.content)

            pdfMake.createPdf(dd).download('Checklist.pdf')
        }

    }

}